export const POLICY_INDUSTRIALISM_CONSTRUCTION_ACTIONS_BONUS = 1;

export const POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_PALACE = 3;
export const POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_WAREHOUSE = 3;
export const POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_MILITARY_CAMP = 3;
export const POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_ARSENAL = 3;
export const POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_FORTRESS = 3;

